<template>
  <div class="container" tabindex="-1" @click="componentClick">
    <div class="mask" v-if="isButton"></div>
    <div class="input__wrapper">
      <span class="input__prefix">
        <span class="input__prefix-inner">
          <i class="icon input__icon search">
            <img class="icon" src="@/assets/icon/search.svg" />
          </i>
        </span>
      </span>
      <input class="input__inner" ref="input" :value="value" type="search" enterkeyhint="search" autocomplete="off" 
        tabindex="0" placeholder="输入文章标题关键词" @input="input" @focus="handleFocus" @blur="focus=false" 
        @change="change" @keyup="search"/>
      <transition name="fade">
      <span class="input__suffix" @click="clearInput" v-show="focus">
        <span class="input__suffix-inner">
          <i class="icon input__icon input__clear">
            <img src="@/assets/icon/close.svg" />
          </i>
        </span>
      </span>
    </transition>
    </div>
    <span v-if="!isButton" class="cancel" @click="$router.go(-1)">取消</span>
  </div>
</template>

<script>
import { aplusButtonClick } from "../lib/qtLIb"

function debounce(func, delay) {
  let debounceTimer;
  return function() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
}

export default {
  name: 'KBSearchInput',
  emits: ['clear', 'search'],
  props: {
    isButton: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number]
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    catalogName: {  // 添加新的 prop
      type: String,
      default: ''
    }
  },
  data () {
    return {
      focus: false,
      isFromClear: false,
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  mounted () {
    if (!this.isButton)this.$refs.input.focus()
  },
  methods: {
    handleFocus () {
      this.focus = true
      // 如果由clearInput触发的focus，不执行上报事件
      if (this.isFromClear) {
        this.isFromClear = false
        return
      }
      // 根据当前tab定义是星学识还是星探索内触发的上报事件
      const eventName = this.tabIndex === 0 ? 'sllp_search_clk' : 'selp_search_clk'
      window.console.log('eventName:', eventName)
      aplusButtonClick({
        // eslint-disable-next-line @typescript-eslint/camelcase
        event_name: eventName,
        // eslint-disable-next-line @typescript-eslint/camelcase
        current_category: this.catalogName
      })
    },
    clearInput () {
      this.isFromClear = true  // 标识是从清空按钮触发的
      this.$emit('change', '')  // 通知父组件更新值
      this.$emit('search', '')  // 清空搜索结果
      // this.$refs.input.value = ''  // 直接清空输入框的值
      this.$refs.input.focus()  // 保持输入框焦点
    },
    input (event) {
      this.$emit('change', event.target.value)
      this.focus = true
    },
    componentClick () {
      if (this.isButton) {
        this.$emit('componentClick')
      }
    },
    change: debounce(function(event){
      this.$emit('change', event.target.value)
    }, 300),
    search: debounce(function(event){
      if (event.key === 'Enter') {
        this.$emit('search', event.target.value)
        this.$refs.input.blur()
      }
    }, 300),
  }
}
</script>

<style scoped lang="scss">
@import "@/scss";

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

img {
  width: 100%;
  height: 100%;
}
.container {
  display: flex;
  margin: 0 auto;
  position: relative;
  align-items: center;
  font-size: 14px;
  padding: 9px 15px;
  background-color: #fff;
}

  .cancel {
    margin-left: 10px;
  }

  .mask {
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
.input__wrapper {
  align-items: center;
  background-color: #f4f4f4;
  border-radius: 14px;
  cursor: text;
  display: inline-flex;
  flex-grow: 1;
  justify-content: center;
  padding: 1px 11px;


  .input__prefix {
    color: #aaa;
    display: inline-flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    height: 100%;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
  }

  .input__prefix-inner {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    pointer-events: all;
  }
  .search {
    margin-right: 4px;
  }

  .input__icon {
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
    width: 20px;
    fill: currentColor;
  }

  .input__inner {
    -webkit-appearance: none;
    background: none;
    border: none;
    box-sizing: border-box;
    color: #000;
    flex-grow: 1;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
    outline: none;
    padding: 0;
    width: 100%;
  }

  .input__suffix {
    color: #aaa;
    display: inline-flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    text-align: center;
    white-space: nowrap;
  }

}
</style>